module.exports = __webpack_public_path__ + "media/images/sample_img01-352425dfab26ed10eb3242965f25928f.png";